import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";

import { getPlanAccountActions } from "@/App/actions";
import { PageAlert } from "@/App/components";
import { ActionTypes } from "@/App/constants/actionTypes";
import apiService from "@/App/service";

export function* getPlanAccount(payload: string): Generator {
  return yield apiService({
    url: "/plan_account/get",
    method: "POST",
    data: {
      id: payload,
    },
  });
}

function* getPlanAccountWorker(action: ReturnType<typeof getPlanAccountActions.getPlanAccount>): SagaIterator {
  const { payload } = action;
  const { showPageAlert } = PageAlert;
  const { getPlanAccountResults } = getPlanAccountActions;

  try {
    const memberPlanAccount = yield call(getPlanAccount, payload);
    yield put(getPlanAccountResults(memberPlanAccount));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* memberInformationWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.GET_PLAN_ACCOUNT, getPlanAccountWorker);
}
